import { render, staticRenderFns } from "./ReferenceLetter.vue?vue&type=template&id=c707d6d4&scoped=true"
import script from "./ReferenceLetter.vue?vue&type=script&lang=js"
export * from "./ReferenceLetter.vue?vue&type=script&lang=js"
import style0 from "./ReferenceLetter.vue?vue&type=style&index=0&id=c707d6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c707d6d4",
  null
  
)

export default component.exports